module.exports = __webpack_public_path__ + "img/blockchain.4cdc703f.svg";